export default "__VITE_ASSET__DG0P2tv8__"